var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UsersListVisor',{attrs:{"users":_vm.userViewers,"isLoading":_vm.isLoading,"hasMore":_vm.hasMore,"detail":'Usuarios que han visto el concurso:',"closeModal":_vm.close,"getMore":_vm.getMoreViewers}})
}
var staticRenderFns = []

export { render, staticRenderFns }